export default class Cookies {

  constructor(name, url, selector, domain, showLogs = false) {
    this.showLogs = showLogs;

    this.cookieName = name;
    this.cookieUrl = url;
    this.cookieDomain = domain || this.getGlobalDomain();

    this.cookieNameAD = 'ad_storage';
    this.cookieNameUD = 'ad_user_data';
    this.cookieNamePR = 'ad_personalization';
    this.cookieNameST = 'analytics_storage';

    this.cookiePosition = selector || '.page__footer';

    this.cookieCheck = document.cookie.indexOf(this.cookieName);

    let cDate = new Date();
    cDate.setTime(cDate.getTime() + 365 * 24 * 60 * 60 * 1000);
    this.cookieDate = cDate.toUTCString();

  }

  checkCookie() {
    console.log(this.cookieDate);
    console.log(this.cookieUrl);
    console.log(this.cookieName);
    console.log(this.cookiePosition);
    console.log(this.cookieCheck);
  }

  getGlobalDomain(customUrl) {
    const url = customUrl || window.location.hostname;

    // Match the main domain using a regular expression
    const matchUrl = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?]+)/im);

    if (matchUrl && matchUrl.length > 1) {
      let mainDomain = matchUrl[1];

      if (mainDomain.split('.').length > 2) {
        mainDomain = mainDomain.split('.').slice(1).join('.');
      }

      return `.${mainDomain}`;
    }

    return url;
  }

  async initialize() {
    const _this = this;

    try {
      const request = new XMLHttpRequest();
      request.open('GET', this.cookieUrl);
      request.send();
      request.addEventListener('load', function () {
        _this.modalCookie(this.responseText);
      });
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(error.message);
      }

      throw new Error('Unknown Error');
    }
  }

  async modalCookie(data) {
    $(this.cookiePosition).append(data);

    const cookieName = this.cookieName;
    const cookieNameAD = this.cookieNameAD;
    const cookieNameUD = this.cookieNameUD;
    const cookieNamePR = this.cookieNamePR;
    const cookieNameST = this.cookieNameST;
    const cookieDate = this.cookieDate;

    const showLogs = this.showLogs;

    const domain = this.cookieDomain;

    if (showLogs)
      console.log('Cookie log - Level 1', cookieName, cookieNameAD, cookieNameUD, cookieNamePR, cookieNameST, cookieDate, domain);

    const cookie_event = new CustomEvent("cookie_update", { 'detail': 'cookie update' });

    $('.cookieDescTitile').on('click', function () {
      $(this).toggleClass('collapsed');
      $(this).siblings('.collapse').slideToggle();
    });

    $('#cookie-change-desc').on('click', function (event) {
      $('.cookie-desc').hide();
      $('.cookie-form').show();
    });

    $('#cookie-change-form').on('click', function (event) {
      $('.cookie-form').hide();
      $('.cookie-desc').show();
    });

    if (
      document.cookie
        .split(';')
        .some((item) => item.includes(cookieNameAD + '=true'))
    )
      $('#ad_storage').prop('checked', true);

    if (
      document.cookie
        .split(';')
        .some((item) => item.includes(cookieNameST + '=true'))
    )
      $('#st_storage').prop('checked', true);

    $(
      '#cookie-accepted-all, #cookie-accepted-form-all, #cookie-accepted-form'
    ).on('click', function (event) {
      console.log($(this).attr('id'));

      if (
        $(this).attr('id') === 'cookie-accepted-all' ||
        $(this).attr('id') === 'cookie-accepted-form-all'
      ) {
        $('#ad_storage').prop('checked', true);
        $('#st_storage').prop('checked', true);
      }
      if (showLogs) {
        console.log('Cookie log - Accepted - Level 1', `${cookieName}=1; expires=${cookieDate}; domain=${domain}; path=/`);
        console.log('Cookie log - Accepted - Level 2', `${cookieNameAD}=${$('#ad_storage').prop('checked')}; expires=${cookieDate}; domain=${domain}; path=/`);
      }

      document.cookie = `${cookieName}=1; expires=${cookieDate}; domain=${domain}; path=/`;
      document.cookie = `${cookieNameAD}=${$('#ad_storage').prop(
        'checked'
      )}; expires=${cookieDate}; domain=${domain}; path=/`;
      document.cookie = `${cookieNameUD}=${$('#ad_storage').prop(
        'checked'
      )}; expires=${cookieDate}; domain=${domain}; path=/`;
      document.cookie = `${cookieNamePR}=${$('#ad_storage').prop(
        'checked'
      )}; expires=${cookieDate}; domain=${domain}; path=/`;
      document.cookie = `${cookieNameST}=${$('#st_storage').prop(
        'checked'
      )}; expires=${cookieDate}; domain=${domain}; path=/`;

      if (showLogs) console.log('Cookie log - Accepted - Level 3', document.cookie);

      gtag('consent', 'update', {
        ad_storage: $('#ad_storage').prop('checked') ? 'granted' : 'denied',
        ad_user_data: $('#ad_storage').prop('checked') ? 'granted' : 'denied',
        ad_personalization: $('#ad_storage').prop('checked') ? 'granted' : 'denied',
        analytics_storage: $('#st_storage').prop('checked') ? 'granted' : 'denied',
      });
      gtag(
        'set',
        'ads_data_redaction',
        $('#ad_storage').prop('checked') ? false : true
      );
      dataLayer.push({
        event: 'cookie_consent_update',
      });

      document.dispatchEvent(cookie_event);
      $('#cookiemodal').hide();
    });

    $('#cookiemodal_show').on('click', function () {
      $('.cookie-desc').hide();
      $('.cookie-form').show();
      $('#cookiemodal').show();
    });

    if (this.cookieCheck === -1) {
      setTimeout(() => {
        $('#cookiemodal').show();
      }, 1000);
    }
  }
}
